exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-table thead.is-group th.el-table__cell {\r\n  background: #f2a659;\r\n  color: #333333;\n}\r\n", ""]);

// exports
